import { SortDirection } from '@tanstack/react-table';
import * as React from 'react';
import { TableHeaderUnsortedIcon, TableHeaderArrowDownIcon, TableHeaderArrowUpIcon } from '@/storybook/icons';
import styles from '../Table.module.scss';

const sortingComponents = {
  asc: TableHeaderArrowUpIcon,
  desc: TableHeaderArrowDownIcon,
  idle: TableHeaderUnsortedIcon,
};

export const SORTING_INDICATOR_TEST_ID = 'sorting-indicator';
export const getSortingPriorityTestId = (priority: number): string => `sorting-priority-${priority}`;

type SortingIndicatorProps = {
  isSorted: false | SortDirection;
  priority?: number;
};

const SortingIndicator = ({ isSorted, priority }: SortingIndicatorProps) => {
  const SortingComponent =
    isSorted === 'asc' || isSorted === 'desc' ? sortingComponents[isSorted] : sortingComponents.idle;

  return (
    <span className={styles.sortingIndicator} data-testid={SORTING_INDICATOR_TEST_ID} data-sorted={Boolean(isSorted)}>
      <SortingComponent />
      {priority !== undefined ? (
        <span
          className={styles.sortingPriorityBadge}
          data-testid={getSortingPriorityTestId(priority)}
          data-sort-priority={priority}
        >
          {priority}
        </span>
      ) : null}
    </span>
  );
};

export default SortingIndicator;
